module.exports = __webpack_public_path__ + "static/61602538_1286657268166009_3886242643151159296_o_optimized-772ec810282ae63d9e7d1afe51a834a4.jpg";